import {
    LIST_INTERMEDIATES,
    LIST_INTERMEDIATES_SUCCESS,
    LIST_INTERMEDIATES_ERROR,
    ADD_INTERMEDIATES,
    SAVE_INTERMEDIATES,
    SAVE_INTERMEDIATES_SUCCESS,
    SAVE_INTERMEDIATES_ERROR,
    DELETE_INTERMEDIATES,
    DELETE_INTERMEDIATES_SUCCESS,
    DELETE_INTERMEDIATES_ERROR,
    EDIT_INTERMEDIATES,
    UPDATE_INTERMEDIATES,
    UPDATE_INTERMEDIATES_SUCCESS,
    UPDATE_INTERMEDIATES_ERROR
} from '../types';

import clienteAxios from '../config/axios';
import { ErrorMessage, SuccessMessage, WaitingMessage } from '../components/extras/toastMessages';
import { MSG_CREATE_SUCCESS, MSG_UPDATE_SUCCESS, MSG_DELETING, MSG_DELETE_SUCCESS } from '../constants/messages';
import Swal from 'sweetalert2';

const controller = 'intermedio';


//LISTAR INTERMEDIATES
export function listIntermediatesAction(audience) {
    return async (dispatch) => {
        //Inicializo
        dispatch( listIntermediates() );
        //Ejecuto la consulta
        try
        {   //Hago la consulta
            const response = await clienteAxios.get(`/${controller}?search=audiencia.id:${audience.id}&sort=id:desc`);
            //Obtengo los datos
            const intermediates = response.data;
            //Llamo al dispatch
            dispatch( listIntermediatesSuccess(intermediates.content) );
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( listIntermediatesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}
const listIntermediates = () => ({
    type: LIST_INTERMEDIATES,
    payload: true
});
const listIntermediatesSuccess = intermediates => ({
    type: LIST_INTERMEDIATES_SUCCESS,
    payload: intermediates
});
const listIntermediatesError = error => ({
    type: LIST_INTERMEDIATES_ERROR,
    payload: error
});

//ADD AUDIENCE CATEGORY
export function addIntermediatesAction(showForm) {
    return (dispatch) => {
        //Inicializo
        dispatch( addIntermediates(false) );
        //Abro el formulario
        showForm();
    }
}
const addIntermediates = isEdit => ({
    type: ADD_INTERMEDIATES,
    payload: isEdit
});

//SAVE AUDIENCE CATEGORY
export function saveIntermediatesAction(intermediate, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( saveIntermediates() );
        //Ejecuto la consulta
        try
        {   //Hago la consulta
            const response = await clienteAxios.post(`/${controller}`, intermediate);
            //Llamo al dispatch
            dispatch( saveIntermediatesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_CREATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( saveIntermediatesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}
const saveIntermediates = () => ({
    type: SAVE_INTERMEDIATES,
    payload: true
});
const saveIntermediatesSuccess = intermediate => ({
    type: SAVE_INTERMEDIATES_SUCCESS,
    payload: intermediate
});
const saveIntermediatesError = error => ({
    type: SAVE_INTERMEDIATES_ERROR,
    payload: error
});

//EDIT AUDIENCE CATEGORY
export function editIntermediatesAction(intermediate, showForm) {
    return async (dispatch) => {
        //Inicializo
        dispatch( editIntermediates(intermediate) );
        //Abro el formulario
        showForm();
    }
}
const editIntermediates = intermediate => ({
    type: EDIT_INTERMEDIATES,
    payload: intermediate
});

//UPDATE AUDIENCE CATEGORY
export function updateIntermediatesAction(intermediate, handleClose) {
    return async (dispatch) => {
        //Inicializo
        dispatch( updateIntermediates() );
        //Ejecuto la consulta
        try
        {   //Hago la consulta
            const response = await clienteAxios.put(`/${controller}/${intermediate.id}`, intermediate);
            //Llamo al dispatch
            dispatch( updateIntermediatesSuccess(response.data) );
            //Cierro la ventana
            handleClose();
            //Mensaje
            SuccessMessage(MSG_UPDATE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateIntermediatesError(data) );
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}
const updateIntermediates = () => ({
    type: UPDATE_INTERMEDIATES,
    payload: true
});
const updateIntermediatesSuccess = intermediate => ({
    type: UPDATE_INTERMEDIATES_SUCCESS,
    payload: intermediate
});
const updateIntermediatesError = error => ({
    type: UPDATE_INTERMEDIATES_ERROR,
    payload: error
});

//DELETE AUDIENCE CATEGORY
export function deleteIntermediatesAction(intermediate) {
    return async (dispatch) => {
        //Inicializo
        dispatch( deleteIntermediates() );
        //Mensaje de Espera
        WaitingMessage(MSG_DELETING);
        //Ejecuto la consulta
        try
        {   //Hago la consulta
            const response = await clienteAxios.delete(`/${controller}/${intermediate.id}`);
            //Llamo al dispatch
            if(response) dispatch( deleteIntermediatesSuccess(intermediate.id) );
            //Oculto espera
            Swal.close();
            //Mensaje
            SuccessMessage(MSG_DELETE_SUCCESS);
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Llamo al dispatch
            dispatch( deleteIntermediatesError(data) );
            //Oculto espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}
const deleteIntermediates = () => ({
    type: DELETE_INTERMEDIATES,
    payload: true
});
const deleteIntermediatesSuccess = intermediate => ({
    type: DELETE_INTERMEDIATES_SUCCESS,
    payload: intermediate
});
const deleteIntermediatesError = error => ({
    type: DELETE_INTERMEDIATES_ERROR,
    payload: error
});